import { useMutation, useQueryClient } from "@tanstack/react-query";

import { savedSegmentSchema } from "../schemas";

import { campaignQueryKeys } from "@/features/campaigns/api/queryKeys";
import { segmentsQueryKeys } from "@/features/segments/api/queryKeys";
import type { SaveSegmentRequest } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

const CAMPAIGN_REFRESH_DELAY_MS = 3000;

type UseSaveSegmentParams = {
  segmentId?: string;
};

type SaveSegmentVariables = {
  request: SaveSegmentRequest;
  segmentId?: string;
};

export function useSaveSegment({ segmentId }: UseSaveSegmentParams) {
  const queryClient = useQueryClient();

  return useMutation<string, Error, SaveSegmentVariables>({
    mutationFn: async ({ request, segmentId: targetId = segmentId }) => {
      if (targetId) {
        await instance.put(`/api/v2/Segments/${targetId}`, request);
        return targetId;
      }
      const response = await instance.post("/api/v2/Segments", request);
      return savedSegmentSchema.parse(response.data).id;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.all });
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: campaignQueryKeys.all,
          refetchType: "all",
        });
      }, CAMPAIGN_REFRESH_DELAY_MS);
    },
  });
}
